import { useEffect, useState } from "react"
import './style.css'
import ProjectLibraryItem from "./ProjectLibraryItem"
import CustomButton from "../../components/CustomButton"
import { useDispatch, useSelector } from "react-redux"
import { clearCompareObjectAction, clearDeleteAction, getMinMaxCostsAction, getProjectsAnalogsAction, getSummaryCostsAction } from "./store/actions"
import Filters from "./Filters"
import { Input, Space, Switch } from "antd"
import Notifications from "../../helpers/Notifications"
import { useTranslation } from "react-i18next"
import CustomPagination from "../../components/CustomPagination"
import { Link } from "react-router-dom"
import CompareForm1 from "./CompareForm/CompareForm1"
import CompareForm2 from "./CompareForm/CompareForm2"
import isRole from "../../helpers/userHelper"

const ProjectLibrary = (props) => {
    const dispatch = useDispatch()
    const { t } = useTranslation(['manage', 'project'])
    const { user } = useSelector(state => state.userReducer)
    const isModify = isRole(["mainAdmin", "analogObjectsMainAdmin", "analogObjectsProjectAdmin"], user)
    const { projectAnalogsList, deleted, isLoading, compareObjects } = useSelector(state => state.projectReducer)

    //const [withoutArchive, setWithoutArchive] = useState(true)
    const [page, setPage] = useState(1)
    const [filters, setFilters] = useState({
        floors: [null, null],
        appartments: [null, null],
        commonSquare: [null, null],
        withoutArchive: true
    })
    const [searchValue, setSearchValue] = useState('')
    const [viewBlock, setViewBlock] = useState('default')
    const pageSize = 6

    const getProjectsAnalog = (values) => {
        dispatch(getProjectsAnalogsAction(values))
    }



    useEffect(() => {
        if (deleted) {
            Notifications.successNotice(t('manage:deletedProjectSuccess', '', 15))
            dispatch(clearDeleteAction())

            onPaginationChange(page)
        }
    }, [deleted])

    useEffect(() => {
        setPage(1)
        onPaginationChange(1)
    }, [filters])

    useEffect(() => {
        if (page)
            onPaginationChange(page)
    }, [page])

    const onPaginationChange = (value) => {
        setPage(value)
        getProjectsAnalog({
            page: value,
            pageSize,
            ...filters
        })
    }

    const handleSearch = () => {
        setFilters({
            ...filters,
            analogProjectName: searchValue
        })
    }

    const switchArchiveChange = (checked) =>{
       // setWithoutArchive(checked)
        setFilters({
            ...filters,
            withoutArchive: checked
        })
    }

    // useEffect(() => {
    //     handleSearch()
    // }, [withoutArchive])

    return (<>
        <div className="projects__header">
            <Link to="/">
                <div className="project__link__back">
                    <img alt="" src="/Arrow.svg" />
                    {t("common:back")}
                </div>
            </Link>
            <h2>{t("project:projectBank")}</h2>
        </div>
        <div className="projects__library">

            <Filters
                filters={filters}
                setFilters={setFilters}
                setSearchValue={setSearchValue}
            ></Filters>
            <div className="project__library__wrapper">
                {viewBlock === "default" ?
                    <>
                        <div className="project__search__wrapper">
                            <Input
                                value={searchValue}
                                placeholder={t('project:writeNameProjectOrCodeObject')}
                                onChange={(e) => { setSearchValue(e.target.value) }}
                                onPressEnter={handleSearch}
                                suffix={<img alt="" src="/Search.svg" onClick={handleSearch}></img>}
                                className="project__search__input"
                            ></Input>
                            {
                                isModify &&
                                (
                                    <CustomButton href={'/createProject'} block type="green" shape="round" className="createProject-button">
                                        Создать новый проект
                                    </CustomButton>
                                )
                            }
                        </div>
                        <div className="project__search__wrapper">
                            <p> <Space direction="vertical">
                                <Switch
                                    checkedChildren="Без Архива"
                                    unCheckedChildren="С Архивом"
                                    checked= {filters.withoutArchive ?? true}
                                    onChange={switchArchiveChange}
                                />
                            </Space></p>

                        </div>
                        {compareObjects?.length > 1 ?
                            <div className="compare__buttons">
                                <CustomButton
                                    onClick={() => {
                                        dispatch(getSummaryCostsAction({ analogObjectIds: compareObjects }))
                                        setViewBlock("compareForm1")
                                    }}
                                >
                                    Сравнить по форме 1
                                </CustomButton>
                                <CustomButton
                                    onClick={() => {
                                        dispatch(getMinMaxCostsAction({ analogObjectIds: compareObjects }))
                                        setViewBlock("compareForm2")
                                    }}
                                >
                                    Сравнить по форме 2
                                </CustomButton>
                                <CustomButton
                                    type="grey"
                                    onClick={() => dispatch(clearCompareObjectAction())}
                                >
                                    Сбросить
                                </CustomButton>
                            </div>
                            : null}
                        <div className="project__library__list">

                            {projectAnalogsList?.items?.length > 0 ? projectAnalogsList.items.map((item, index) => {
                                return <ProjectLibraryItem item={item} key={index} isModify={isModify}></ProjectLibraryItem>
                            }) :
                                <p className="project__not__found">
                                    {`${isLoading ? 'Идёт загрузка проектов...' : 'Проектов с таким фильтром нет..'}`}
                                </p>
                            }
                        </div>
                        {projectAnalogsList?.count > pageSize && <CustomPagination
                            current={page}
                            onChange={(val) => setPage(val)}
                            pageSize={pageSize}
                            total={projectAnalogsList?.count}
                            showSizeChanger={false}
                            className="project__library__pagination"
                        >
                        </CustomPagination>}
                    </>
                    : null}

                {viewBlock === "compareForm1" ?
                    <CompareForm1
                        setViewBlock={setViewBlock}
                    />
                    : null}
                {viewBlock === "compareForm2" ?
                    <CompareForm2
                        setViewBlock={setViewBlock}
                    />
                    : null}
            </div>
        </div>
    </>
    )
}

export default ProjectLibrary
